<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" >
    <div class="row">
      <div class="col" style="overflow-wrap: anywhere;">
        <ng-template [ngIf]="!messageHtml"><label>{{message}}</label></ng-template>
        <ng-template [ngIf]="messageHtml"><label [innerHtml]="messageHtml"></label></ng-template>
      </div>
    </div>
</div>


<div class="modal-footer">
  <ng-template [ngIf]="askExtraConfirmation"><label class="form-check-label">
    <input type="checkbox" name="status" class="form-check-input" [(ngModel)]="extraConfirmation">
    {{'YesIKnowWhatIamDoing' | translate}}
  </label></ng-template>
  <button type="button" class="btn btn-primary" [disabled]="(askExtraConfirmation && !extraConfirmation)" (click)="onValidate()">{{positiveButtonTitleCode | translate}}</button>
  <button type="button" class="btn btn-link" (click)="onCancel()">{{negativeButtonTitleCode | translate}}</button>
</div>

